module.exports = __webpack_public_path__ + "static/media/weather-thumnail.b2ddf99a.png";